import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3f962cd2ad87f131450ca8da54a97060.js')["default"];

var scope_2 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b4dd4968dd0e6928f542162ca5d16de.js')["default"];

var scope_3 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a201d9c59f9b40ff598b4f3fd39fafc8.js')["default"];

var scope_4 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a6f1c561caf6204e2e2b7eddbcd2ec1e.js')["default"];

var scope_5 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b08211407d3b045b43f9e0386dffb9b8.js')["default"];

var scope_6 = require('/Users/lukas/Sites/git/own-packages/react-i18n-kit/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ed3b1dd07821ff34c858f5241de87928.js')["default"];

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6);